import React from 'react'
import { TrialPreEndModalCard } from 'Features/accountSettings/components/Billing/TrialPreEndModal/TrialPreEndModal.styled'
import { useTranslation } from 'react-i18next'
import { ThreatGroupsStyled } from 'Features/accountSettings/components/Billing/TrialPreEndModal/Components/ThreatGroupsPm/ThreatGroupsPm.styled'
import { DrillDownPie } from '@clickcease/cc-client-components-lib'
import { Options, SeriesOptionsType } from 'highcharts'
import { useThreatGroups } from 'Features/home/api/getThreatGroups'
import { NewThreatGroupBreakdownData, ThreatGroupData } from 'Features/home/api/types'
import { useUserStore } from 'Stores/userStoreModuleFed'
import { useGetPlansDetails } from 'Features/accountSettings/api/getPlansDetails'
import { getCountryLabelByCountryValue, toUnixDateRangeFix } from 'Utils/dates'

export const ThreatGroupsPm = () => {
  const { t } = useTranslation('accountSettings')
  const { timezoneCountry } = useUserStore()
  const { data: plansDetails } = useGetPlansDetails()
  const timezone: string = getCountryLabelByCountryValue(timezoneCountry)
  const serverDateConversion = toUnixDateRangeFix(timezoneCountry, {
    from: new Date(plansDetails?.currentPeriodStart || ''),
    to: new Date(),
  })

  const { data: threatGroups } = useThreatGroups(
    {
      domains: [],
      campaigns: [],
      startDate: serverDateConversion?.from,
      endDate: serverDateConversion?.to,
      timezone: timezone,
    },
    !!plansDetails?.currentPeriodStart
  )

  let result: ThreatGroupData[] = []
  if (threatGroups) {
    result = threatGroups?.reduce((acc: ThreatGroupData[], item: NewThreatGroupBreakdownData) => {
      const itemThreatGroup = item.threatGroup.replace('Invalid ', '').replace('optimization ', '')
      const existingItemIndex = acc.findIndex(
        (element) =>
          element.name.replace('Invalid ', '').replace('optimization ', '') === itemThreatGroup
      )

      if (existingItemIndex !== -1) {
        acc[existingItemIndex].drilldownData[itemThreatGroup] += item.invalid
        acc[existingItemIndex].drilldownData.dataObj[item.threatType] = item.invalid
      } else {
        const newItem = {
          name: itemThreatGroup,
          y: item.invalid,
          drilldown: itemThreatGroup,
          drilldownData: {
            type: 'pie',
            name: itemThreatGroup,
            id: itemThreatGroup,
            data: [[item.threatType, item.invalid]],
            dataObj: {
              [item.threatType]: item.invalid,
            },
          },
        } as ThreatGroupData
        acc.push(newItem)
      }
      return acc
    }, [])
  }

  const data = result
  const chartOptions: Options = {
    chart: {
      type: 'pie',
      height: 125,
      width: 320,
    },
    series: [
      {
        name: t('trial_pre_end_modal.threats_groups_types'),
        colorByPoint: true,
        type: 'pie',
        size: '80',
        marginTop: 0,
        marginBottom: 0,
        innerSize: '65%',
        data: data,
      } as SeriesOptionsType,
    ],
    legend: {
      useHTML: false,
      verticalAlign: 'middle',
      itemMarginBottom: 6,
      align: 'right',
      itemStyle: { fontSize: '13px', fontWeight: '300' },
    },
    tooltip: {
      enabled: true,
      outside: false,
      useHTML: true,
      style: {
        zIndex: 100,
      },
    },
  }
  return (
    <TrialPreEndModalCard>
      <ThreatGroupsStyled>{t('trial_pre_end_modal.threats_groups_types')}</ThreatGroupsStyled>
      {threatGroups && (
        <DrillDownPie
          labelOptions={{ hideNumber: true }}
          options={chartOptions}
          chartCSS={{ maxWidth: '301px', height: '100%' }}
          data={data}
        />
      )}
    </TrialPreEndModalCard>
  )
}
